import { useMemo, useRef, useState, useEffect } from "react";
import useDataSelector from "./useDataSelector";

function useGanttChartElements() {
  const [ganttChartBoundingBox, setGanttChartBoundingBox] =
    useState<DOMRect | null>(null);
  const [scrollViewBoundingRect, setScrollViewBoundingRect] =
    useState<DOMRect | null>(null);
  const ganttChartSvg = useRef<SVGSVGElement | null>(null);
  const svgWrapper = useRef<HTMLDivElement>(null);
  const scrollViewContainer = useRef<HTMLDivElement>(null);
  const dataToUse = useDataSelector();

  useEffect(() => {
    if (ganttChartSvg.current) {
      setGanttChartBoundingBox(ganttChartSvg.current.getBoundingClientRect());
    }
    if (scrollViewContainer.current) {
      setScrollViewBoundingRect(
        scrollViewContainer.current.getBoundingClientRect()
      );
    }
  }, [scrollViewContainer, dataToUse]);

  return useMemo(
    () => ({
      ganttChartSvg,
      ganttChartBoundingBox,
      svgWrapper,
      scrollViewContainer,
      scrollViewBoundingRect,
    }),
    [ganttChartBoundingBox, scrollViewBoundingRect]
  );
}

export default useGanttChartElements;
